import { PRECIO_JUSTO_UPDATE_UNSAVED_CHANGES } from './constants'
import initialState from './initialState';

export function updateUnsavedChanges(newValue) {
    return (dispatch) => {
        dispatch({
            type: PRECIO_JUSTO_UPDATE_UNSAVED_CHANGES,
            value: newValue
        })
    }
}

export function reducer(state = initialState, action = {}) {
    if (action.type === PRECIO_JUSTO_UPDATE_UNSAVED_CHANGES) {
        return {...state, unsavedChanges: action.value}
    } else {
        return state
    }
}
